import React, { FC } from 'react';
import { Box, BoxProps } from '@hover/blueprint';

interface Props extends BoxProps {
  color: string;
  borderColor?: string;
  isOutline?: boolean;
}

const Button: FC<Props> = ({
  children,
  color,
  borderColor,
  isOutline,
  ...rest
}) => (
  <Box
    as="button"
    backgroundColor={!isOutline ? color : 'unset'}
    borderRadius="100px"
    fontSize={400}
    fontWeight={700}
    letterSpacing="0.03em"
    textColor={borderColor}
    borderColor={borderColor}
    borderWidth="2px"
    display="flex"
    justifyContent="space-between"
    px="32px"
    py="16px"
    textTransform="uppercase"
    _hover={{
      backgroundColor: !isOutline ? borderColor : 'unset',
      color,
    }}
    {...rest}
  >
    {children}
  </Box>
);

Button.defaultProps = {
  borderColor: 'white',
  isOutline: false,
};

export default Button;
